var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.957 13.1272C21.957 7.63723 17.697 3.90723 12.957 3.90723C8.26703 3.90723 3.95703 7.55723 3.95703 13.1872C3.35703 13.5272 2.95703 14.1672 2.95703 14.9072V16.9072C2.95703 18.0072 3.85703 18.9072 4.95703 18.9072H5.95703V12.8072C5.95703 8.93723 9.08703 5.80723 12.957 5.80723C16.827 5.80723 19.957 8.93723 19.957 12.8072V19.9072H11.957V21.9072H19.957C21.057 21.9072 21.957 21.0072 21.957 19.9072V18.6872C22.547 18.3772 22.957 17.7672 22.957 17.0472V14.7472C22.957 14.0472 22.547 13.4372 21.957 13.1272Z",
    fill: "#2D73C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95703 14.9072C10.5093 14.9072 10.957 14.4595 10.957 13.9072C10.957 13.3549 10.5093 12.9072 9.95703 12.9072C9.40475 12.9072 8.95703 13.3549 8.95703 13.9072C8.95703 14.4595 9.40475 14.9072 9.95703 14.9072Z",
    fill: "#2D73C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.957 14.9072C16.5093 14.9072 16.957 14.4595 16.957 13.9072C16.957 13.3549 16.5093 12.9072 15.957 12.9072C15.4047 12.9072 14.957 13.3549 14.957 13.9072C14.957 14.4595 15.4047 14.9072 15.957 14.9072Z",
    fill: "#2D73C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9575 11.9372C18.719 10.5314 17.9909 9.25519 16.9019 8.33461C15.813 7.41402 14.4334 6.9084 13.0075 6.90723C9.97749 6.90723 6.71749 9.41723 6.97749 13.3572C8.21062 12.8526 9.29973 12.0507 10.1477 11.023C10.9957 9.99531 11.5762 8.77374 11.8375 7.46723C13.1475 10.0972 15.8375 11.9072 18.9575 11.9372Z",
    fill: "#2D73C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSupport);
export default __webpack_public_path__ + "static/media/contact-support.8277254709935bd552e216ca6f8de695.svg";
export { ForwardRef as ReactComponent };